import {ISearchFilters} from "../types/ISearchFilters";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {area} from "./filter_slot_presets/area";
import {constructionEndDate} from "./filter_slot_presets/construction_end_date";
import {houseAdditionalAreas} from "./filter_slot_presets/house_additional_areas";
import {houseStoreys} from "./filter_slot_presets/house_storeys";
import {houseType} from "./filter_slot_presets/house_type";
import {price} from "./filter_slot_presets/price";
import {propertyType} from "./filter_slot_presets/property_type";
import {rooms} from "./filter_slot_presets/rooms";

export const houseSearchFilters: ISearchFilters<ISearchFiltersFormValues> = {
    slots: [propertyType, price, rooms, area, houseType, houseAdditionalAreas, houseStoreys, constructionEndDate]
};
import {ISearchFilters} from "../types/ISearchFilters";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {area} from "./filter_slot_presets/area";
import {constructionEndDate} from "./filter_slot_presets/construction_end_date";
import {houseAdditionalAreas} from "./filter_slot_presets/house_additional_areas";
import {houseStoreys} from "./filter_slot_presets/house_storeys";
import {houseType} from "./filter_slot_presets/house_type";
import {price} from "./filter_slot_presets/price";
import {propertyType} from "./filter_slot_presets/property_type";
import {rooms} from "./filter_slot_presets/rooms";

export const houseSearchFilters: ISearchFilters<ISearchFiltersFormValues> = {
    slots: [propertyType, price, rooms, area, houseType, houseAdditionalAreas, houseStoreys, constructionEndDate]
};
